import { Fieldset } from '../../../../controller/services/comments-service';
export const getPageFieldsets = (options) => [
    Fieldset.MEMBERS,
    Fieldset.REACTIONS,
    Fieldset.MEMBER_BADGES,
    Fieldset.MEMBER_ROLES,
    ...(options.withVotes ? [Fieldset.VOTES] : []),
    ...(options.withRatings ? [Fieldset.RATINGS_SUMMARY, Fieldset.CURRENT_RATING] : []),
];
export const getInitialFieldsets = (options) => [
    Fieldset.CURRENT_MEMBER,
    Fieldset.MEMBERS,
    Fieldset.REGISTRATION_DATA,
    Fieldset.REACTIONS,
    Fieldset.MEMBER_BADGES,
    Fieldset.MEMBER_ROLES,
    Fieldset.TOTAL_COMMENTS,
    Fieldset.FOLLOWED_MEMBERS,
    Fieldset.CONTEXT_PERMISSIONS,
    ...(options.withVotes ? [Fieldset.VOTES] : []),
    ...(options.withRatings ? [Fieldset.RATINGS_SUMMARY, Fieldset.CURRENT_RATING] : []),
];
//# sourceMappingURL=comment-request-utils.js.map